import { isValidDate } from './index';

const isValidRepeat = (frequency: any) => {
    if (!frequency) return false;

    // if (logging) console.log(`valid repeat on date: ${result}`);

    return isValidDate(frequency.repeatOn);
};

export default isValidRepeat;
